import ArrowLeft from "@mui/icons-material/ArrowBackIos";
import ArrowRight from "@mui/icons-material/ArrowForwardIos";
import { Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Paper from "@mui/material/Paper";
import React, { useEffect, useState } from "react";
import { DropdownItem } from "../select/Select";
import styles from "./styles";
import { FieldMetaState, FieldRenderProps } from "react-final-form";

interface Props {
  input: any;
  meta: FieldMetaState<DropdownItem[]>;
  id: string;
  value: string;
  type?: string;
  label: string;
  name: string;
  size?: "small" | "middle" | "big";
  hasError?: boolean;
  isRequired?: boolean;
  errorMessage?: string;
  onChangeValue: any;
  onBlur?: any;
  classes?: any;
  options?: DropdownItem[];
  onAdd?(value: any): void;
  onRemove?(value: any): void;
  disabled?: boolean;
}

const TransferList: React.FC<Props & FieldRenderProps<any, HTMLElement, any>> =
  ({
    label,
    options = [],
    meta,
    input,
    value,
    onAdd,
    onRemove,
    onChangeValue,
    disabled = false,
  }: Props) => {
    const [optionsLeft, setOptionsLeft] = useState(
      options || ([] as DropdownItem[])
    );
    const [choosenOptions, setChoosenOptions] = useState(
      input?.value || meta?.initial || ([] as DropdownItem[])
    );

    useEffect(() => {
      updateOptions();
    }, [options, meta.initial, input.value]);

    const updateOptions = () => {
      const defaultValues = input.value || meta.initial;
      if (options && defaultValues) {
        const choosenOptions = options.filter((item) =>
          defaultValues.find((item2: DropdownItem) => item.key === item2.key)
        );
        const newOptionsLeft = removeToArray(choosenOptions, options);
        setOptionsLeft(newOptionsLeft);
        setChoosenOptions(choosenOptions);
      }
    };
    // useEffect(() => {updateOptions();}, [])

    const removeToArray = (
      checkedValues: DropdownItem[],
      optionsLeft: DropdownItem[]
    ) => {
      return optionsLeft.filter((item) => !checkedValues.includes(item));
    };

    const addToArray = (
      checkedValues: DropdownItem,
      optionsLeft: DropdownItem[]
    ) => {
      return optionsLeft.filter((item) => item.value === checkedValues.value);
    };

    const handleToggle = (value: DropdownItem) => {
      const checkedOptions = addToArray(value, optionsLeft);
      // Retirer de la liste les options à gauche
      const newoptionsLeft = removeToArray([value], optionsLeft);
      setChoosenOptions(choosenOptions.concat(checkedOptions));
      setOptionsLeft(newoptionsLeft);

      if (input) {
        input.onChange(choosenOptions.concat(checkedOptions));
      }
      if (onAdd) {
        onAdd(value);
      }
    };

    const handleToggleRight = (value: DropdownItem) => {
      const newoptionsLeft = optionsLeft.concat(
        addToArray(value, choosenOptions)
      );
      const newchoosenOptions = removeToArray(
        addToArray(value, choosenOptions),
        choosenOptions
      );
      setChoosenOptions(newchoosenOptions);
      setOptionsLeft(newoptionsLeft);

      if (input) {
        input.onChange(newchoosenOptions);
      }
      if (onRemove) {
        onRemove(value);
      }
    };

    const renderCustomList = (items: DropdownItem[], right: boolean) => (
      <Paper className={"paper"}>
        <List component="div" role="list">
          {items.map((item) => {
            const labelId = `transfer-list-item-${item.value}-label`;

            return (
              <ListItem key={item.value} role="listitem" className={"listItem"}>
                <Button
                  id={labelId}
                  className={"buttonList"}
                  color="primary"
                  disabled={disabled}
                  onClick={
                    right
                      ? () => handleToggleRight(item)
                      : () => handleToggle(item)
                  }
                  classes={{
                    root: "rootCheckbox",
                    // label: 'checkbox',
                  }}
                >
                  {item.text || ""}
                </Button>
              </ListItem>
            );
          })}
          <ListItem />
        </List>
      </Paper>
    );

    return (
      <>
        <Typography variant="button">{label}</Typography>
        <Grid
          sx={styles}
          container
          justifyContent="center"
          alignItems="center"
          className={"root"}
        >
          <Grid item>{renderCustomList(optionsLeft, false)}</Grid>
          <Grid item>
            <Grid container direction="column" alignItems="center">
              <Button
                variant="outlined"
                size="small"
                className={"button"}
                disabled
                aria-label="move selected choosenOptions"
              >
                <ArrowRight style={{ fontSize: 20 }} />
              </Button>
              <Button
                variant="outlined"
                size="small"
                className={"button"}
                disabled
                aria-label="move selected optionsLeft"
              >
                <ArrowLeft style={{ fontSize: 20 }} />
              </Button>
            </Grid>
          </Grid>
          <Grid item>{renderCustomList(choosenOptions, true)}</Grid>
        </Grid>
        {meta.error && meta.touched && (
          <Typography color="error" variant="caption">
            {meta.error}
          </Typography>
        )}
      </>
    );
  };

export default TransferList;
